import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import { DualRangeSlider, MultiCheckDropdown, UserHover } from "Components";
import { useFilterList } from "Constant/apiHooks";
import { getFirstLetterOfName } from "Utils";

export const Filters = ({
  show,
  filterList,
  duplicateFilterList,
  setFilterList,
  toggle,
  onApplyFilter,
  onResetFilter,
  // handleFilterSelectChange,
  // handleFilterSliderChange,
  // handleFilterDateChange,
  // handleFilterAssigneeChange,
  // handleFilterCheckboxChange,
  // handleSearchFilter,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  // On Change
  const handleFilterSelectChange = (value, index) => {
    let newArr = [...filterList];
    newArr[index].values = value;
    setFilterList(newArr);
  };

  const handleFilterCheckboxChange = (value, index, checkIndex) => {
    let newArr = [...filterList];
    newArr[index].dropdownValue[checkIndex].checked = value;
    const valueArr = newArr[index].dropdownValue.filter(
      (ele) => ele.checked === true
    );
    newArr[index].values = valueArr;
    setFilterList(newArr);
  };

  const handleFilterSliderChange = (value, id, index) => {
    const newArr = filterList.map((f) => {
      if (f.questionId === id) {
        return {
          ...f,
          noStartRange: Number(value[0]),
          noEndRange: Number(value[1]),
        };
      } else {
        return f;
      }
    });
    // const valueObj = {
    //   lowestNo: value[0],
    //   highestNo: value[1],
    // };
    // newArr[index].values = valueObj;
    newArr[index].norange = value;
    setFilterList(newArr);
  };

  const handleFilterAssigneeChange = (value, index, checkIndex) => {
    let newArr = [...filterList];
    newArr[index].users[checkIndex].isChecked = value;
    const valueArr = newArr[index].users.filter(
      (ele) => ele.isChecked === true
    );
    newArr[index].values = valueArr;
    newArr[index].userFilter = valueArr;
    setFilterList(newArr);
  };

  const handleFilterDateChange = (value, index, type) => {
    let newArr = [...filterList];
    if (type === "startDate") {
      newArr[index].startDate = value;
    } else {
      newArr[index].endDate = value;
    }
    const dateObj = [
      {
        name: "start",
        value: newArr[index].startDate,
        operator: ">=",
      },
      {
        name: "end",
        value: newArr[index].endDate,
        operator: "<",
      },
    ];
    newArr[index].values = dateObj;
    setFilterList(newArr);
  };

  const handleSearchFilter = (value) => {
    let newArr = [...duplicateFilterList];
    if (value.length > 0) {
      const searchedFilter = newArr.filter((option) =>
        option.label.toLowerCase().includes(value.toLowerCase())
      );
      setFilterList(searchedFilter);
    } else {
      setFilterList(duplicateFilterList);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    handleSearchFilter(e.target.value);
  };

  // Submit & Reset
  const onSubmitFilter = () => {
    // const count = filterList.filter(
    //   (ele) => ele.values !== null && ele.values?.length !== 0
    // ).length;
    onApplyFilter(
      filterList
      // count
    );
    toggle();
  };

  // Render
  const filterRender = (filter, index) => {
    if (filter.designType === "select") {
      const dataList =
        filter &&
        filter.dropdownValue &&
        filter.dropdownValue.length > 0 &&
        filter.dropdownValue.map((option) => ({
          value: option.value,
          label: option.name,
        }));
      return (
        // <ReactSelect
        //     isMulti
        //     className="basic-single"
        //     classNamePrefix="select"
        //     isClearableX
        //     isSearchable
        //     name="color"
        //     options={dataList}
        //     value={filter.values}
        //     onChange={(value) => handleFilterSelectChange(value, index)}
        // />
        <MultiCheckDropdown
          options={dataList}
          value={filter.values}
          onChange={(value) => handleFilterSelectChange(value, index)}
        />
      );
    } else if (filter.designType === "number") {
      const rangeValue = filter.norange || [filter.lowestNo, filter.highestNo];
      return (
        <>
          <DualRangeSlider
            questionId={filter.questionId}
            min={filter.lowestNo}
            max={filter.highestNo}
            values={rangeValue}
            onChange={(value, questionId) =>
              handleFilterSliderChange(value, questionId, index)
            }
          />
        </>
      );
    } else if (filter.designType === "date") {
      return (
        <div className="row">
          <div className="col-6">
            <input
              type="date"
              className="form-control form-control-sm"
              value={filter.startDate}
              onChange={(e) =>
                handleFilterDateChange(e.target.value, index, "startDate")
              }
              max={filter.endDate}
            />
          </div>
          <div className="col-6">
            <input
              type="date"
              className="form-control form-control-sm"
              value={filter.endDate}
              onChange={(e) =>
                handleFilterDateChange(e.target.value, index, "endDate")
              }
              min={filter.startDate}
            />
          </div>
        </div>
      );
    } else if (filter.designType === "assignee") {
      return (
        <>
          <div className="search-div">
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                placeholder={t("common.placeHolder.searchAssignee")}
              />
              <button type="button" className="input-group-text">
                <i className="pluto-search"></i>
              </button>
            </div>
          </div>

          <div className="option-list">
            {filter.users &&
              filter.users.length > 0 &&
              filter.users.map((user, userIndex) => (
                <div className="form-check form-check-flex" key={user.userId}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onChange={(e) =>
                      handleFilterAssigneeChange(
                        e.target.checked,
                        index,
                        userIndex
                      )
                    }
                    checked={user.isChecked}
                  />
                  {/* <div className="avatar-img">
                    {user.photoURL ? (
                      <div className="img-box">
                        <img
                          src={user.photoURL}
                          alt={`${user.firstName}${user.lastName}`}
                        />
                      </div>
                    ) : (
                      getFirstLetterOfName(user)
                    )}
                  </div>
                  <label className="form-check-label" htmlFor="">
                    {user.firstName} {user.lastName}
                  </label> */}
                  {/* <UserHover user={user} /> */}

                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Popover className="max-w-unset">
                        <UserHover user={user} />
                      </Popover>
                    }
                  >
                    <div className="d-flex align-items-center ms-1 cursor-pointer">
                      <div className="w-6 h-6 rounded-circle overflow-hidden text-xs">
                        {user.photoURL ? (
                          <div className="img-box w-100 h-100">
                            <img
                              src={user.photoURL}
                              alt={`${user.firstName}${user.lastName}`}
                              className="w-100 h-100 object-fit-cover d-block"
                            />
                          </div>
                        ) : (
                          getFirstLetterOfName(user)
                        )}
                      </div>

                      <div className="avatar-short-dtls ms-2">
                        <label className="form-check-label">
                          {user.firstName} {user.lastName}
                        </label>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              ))}
          </div>
        </>
      );
    } else if (filter.designType === "status") {
      return (
        <div className="option-list">
          {filter.dropdownValue &&
            filter.dropdownValue.length > 0 &&
            filter.dropdownValue.map((status, statusIndex) => (
              <div
                className="form-check form-check-flex form-check-sm mb-2"
                key={`${status.name}${statusIndex}`}
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  onChange={(e) =>
                    handleFilterCheckboxChange(
                      e.target.checked,
                      index,
                      statusIndex
                    )
                  }
                  checked={status.checked}
                />
                <label className="form-check-label ms-2" htmlFor="">
                  {status.name}
                </label>
              </div>
            ))}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <Modal
      className="modal text-start fade right modal-slider filter-modal"
      show={show}
      onHide={toggle}
    >
      <Modal.Header closeButton>
        <h3 className="modal-title">{t("auth.projects.filters.title")}</h3>
      </Modal.Header>
      <div className="search-div">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder={t("common.placeHolder.searchField")}
            value={search}
            onChange={handleSearch}
          />
          <button type="button" className="input-group-text">
            <i className="pluto-search"></i>
          </button>
        </div>
      </div>
      <Modal.Body>
        {filterList && filterList.length > 0 && (
          <Accordion defaultActiveKey={filterList[0].questionId}>
            {filterList.map((filter, index) => {
              return (
                <Accordion.Item
                  eventKey={filter.questionId}
                  key={`${filter.questionName}${index}`}
                >
                  <Accordion.Header>{filter.label}</Accordion.Header>
                  <Accordion.Body>{filterRender(filter, index)}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={onResetFilter}
        >
          {t("common.button.reset")}
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onSubmitFilter}
        >
          {t("common.button.apply")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
